import React from 'react';
import { shape, arrayOf, func, string, bool, object, number, oneOfType } from 'prop-types';
import KeywordFilter from './keyword-filter/';
import DropdownFilter from './dropdown-filter/';
import MultiCheckboxFilter from './multi-checkbox-filter/';
import SingleCheckboxFilter from './single-checkbox-filter/';
import TagFilter from './tag-filter/';
import * as FilterTypeConstants from '../constants/filter-types';
import { getActiveValues } from '../utils/active-filters';

export default function FiltersSection({
    filters, filterSettings, activeFilters, toggleFilters,
    resetFilterGroup, focusedFilter, toggleFocus
}) {
    return (
        <div className="filters-section">
            <div className="filters-container">
                <div className="container">
                    <div className={`filters filter-count-${filters.length}`}>
                        {filters.map(filter => {
                            const activeValues = getActiveValues(filter, activeFilters);
                            switch (filter.type) {
                                case FilterTypeConstants.FILTER_TYPE_KEYWORDS:
                                    return (
                                        <KeywordFilter
                                            key={filter.code}
                                            filter={filter}
                                            keyword={activeValues.length ? activeValues[0] : ''}
                                            updateKeyword={toggleFilters}
                                            placeholderText={filterSettings.keywordPlaceholderText ? filterSettings.keywordPlaceholderText : 'Enter keywords'}
                                            classModifier="filter-item"
                                        />
                                    );

                                case FilterTypeConstants.FILTER_TYPE_MULTI_CHECKBOX:
                                    return (
                                        <MultiCheckboxFilter
                                            key={filter.code}
                                            filter={filter}
                                            selectedItems={activeValues}
                                            toggleFilters={toggleFilters}
                                            classModifier="filter-item"
                                            isFocused={focusedFilter === filter.code}
                                            toggleFocus={toggleFocus}
                                        />
                                    );

                                case FilterTypeConstants.FILTER_TYPE_DROPDOWN:
                                    return (
                                        <DropdownFilter
                                            key={filter.code}
                                            filter={filter}
                                            selectedItems={activeValues}
                                            toggleFilters={toggleFilters}
                                            classModifier="filter-item"
                                            isFocused={focusedFilter === filter.code}
                                            toggleFocus={toggleFocus}
                                        />
                                    );

                                case FilterTypeConstants.FILTER_TYPE_SINGLE_CHECKBOX:
                                    return (
                                        <SingleCheckboxFilter
                                            key={filter.code}
                                            filter={filter}
                                            isChecked={activeValues.length ? (filter.values[0] === activeValues[0]) : false} // eslint-disable-line max-len
                                            toggleFilters={toggleFilters}
                                            classModifier="filter-item"
                                        />
                                    );

                                case FilterTypeConstants.FILTER_TYPE_TAGS:
                                    return (
                                        <TagFilter
                                            key={filter.code}
                                            filter={filter}
                                            selectedItems={activeValues}
                                            toggleFilters={toggleFilters}
                                            resetFilterGroup={resetFilterGroup}
                                            classModifier="filter-item"
                                            isFocused={focusedFilter === filter.code}
                                            toggleFocus={toggleFocus}
                                        />
                                    );

                                default:
                                    return null;
                            }
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}

FiltersSection.defaultProps = { focusedFilter: null };
FiltersSection.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    filters: arrayOf(shape({
        code: string.isRequired,
        label: string.isRequired,
        values: arrayOf(oneOfType([string, bool, number])).isRequired
    })).isRequired,
    filterSettings: shape({
        itemsPerPage: number,
        showResultCount: bool,
        showActiveFilters: bool,
        activeFiltersStyle: string,
        activeFiltersLabel: string,
        keywordPlaceholderText: string,
        keywordSearchableFields: arrayOf(string),
        sortBy: arrayOf(object)
    }).isRequired,
    activeFilters: arrayOf(shape({
        code: string.isRequired,
        label: string.isRequired,
        values: arrayOf(oneOfType([string, bool, number])).isRequired
    })).isRequired,
    focusedFilter: string,
    toggleFilters: func.isRequired,
    resetFilterGroup: func.isRequired,
    toggleFocus: func.isRequired
    /* eslint-enable react/no-typos */
};



// WEBPACK FOOTER //
// ./src/components/filtered-listing/filters/index.jsx